import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweet } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweet';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweet;
  type?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType;
};
